// extracted by mini-css-extract-plugin
export var gif = "_lf-0";